(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define("VueFormJsonSchema", ["Vue"], factory);
	else if(typeof exports === 'object')
		exports["VueFormJsonSchema"] = factory(require("Vue"));
	else
		root["VueFormJsonSchema"] = factory(root["Vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__61__) {
return 